import { useState } from 'react';
import { ContentWrapper, Notification } from '@eti/components';
import { Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';

import { getPriceNotificationContent } from '../../../utils/notification';

const contentWrapperStyles = css`
  margin: 2rem auto 1rem;
`;

type OldAndNewPrice = {
  priceNew: string;
  priceOld: string;
};

type TripChange = {
  price?: OldAndNewPrice;
};

interface PriceChangeNotificationProps {
  tripChange: TripChange;
}

const PriceChangeNotification = ({ tripChange }: PriceChangeNotificationProps) => {
  const { t } = useTranslation();
  const [showPriceChangeNotification, setShowPriceChangeNotification] = useState(
    Boolean(tripChange?.price),
  );

  if (!showPriceChangeNotification) {
    return null;
  }

  const priceIncreaseMessage = t('Notification.PriceIncrease.Message');
  const notificationMessage = getPriceNotificationContent({
    tripChange,
    higherText: priceIncreaseMessage,
  });

  return (
    <ContentWrapper className={contentWrapperStyles}>
      <Notification
        className="priceNotification"
        closeButtonDataTestId="travelerDetails-priceChangeCloseButton-button"
        dataTestId="travelerDetails-priceChange-TripNotification"
        onClose={() => setShowPriceChangeNotification(false)}
      >
        <Text asHtml>{notificationMessage}</Text>
      </Notification>
    </ContentWrapper>
  );
};

export default PriceChangeNotification;
